import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { DevicesService } from 'src/app/modules/configuration/devices/devices.service';
import { FileManagerService } from 'src/app/modules/file-manager/file-manager.service';
import { TdoImagingService } from 'src/app/main-interface/imaging/tdo-imaging.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TdoOrganizerSlideshowDialogComponent } from 'src/app/main-interface/organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DEVICE_CATEGORY } from 'src/app/models/constants/device-category.model';

@Injectable({
  providedIn: 'root'
})
export class TDOPrintService {

  constructor(private readonly http: HttpClient,
    private readonly localStorageService: LocalStorageService,
    private readonly devsService: DevicesService,
    private readonly fileManagerService: FileManagerService,
    private readonly drawService: TdoImagingService,
    private readonly dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  printReport(reportID: string, reportParams: any) 
  { 
    return this.http.post<string>(`api/reports/generateReport/${reportID}`, reportParams);
  }

  async printDocument(documentsID: string[]): Promise<boolean> 
  {
    let res = await this.fileManagerService.getDocuments(documentsID).toPromise();
    return new Promise<boolean>((resolve) => {
      this.drawService.isServiceBrokerRunning(() => {
        const intervalSubscription = setInterval(_ => {
          if (this.drawService.isSBRunning === true) {
            clearInterval(intervalSubscription);
            this.drawService.sendSBPrint(res, () => {
              resolve(true);
            });
          } else {
            clearInterval(intervalSubscription);
            resolve(false);
          }
        }, 100);
      });
    });
  }

  async executePrint(documentsID: string[]): Promise<void> {
   try 
   {
    const isValidPrinter = await this.validatePrinter();
      if (isValidPrinter) 
      {
        let result  = await this.printDocument(documentsID);
        if (result) {
          this.createMessage('Document has been sent to the printer.', 'success');
        } else 
        {
          this.openReport({model: {DocumentID: documentsID[0]}});
        }
      } else {
        this.openReport({model: {DocumentID: documentsID[0]}});
      }
    } catch (error) {
      this.createMessage('Error when trying to print Document.', 'error');
  }
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

    
  async validatePrinter(){
    const WorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
    
    let ddata = await this.devsService.getAttachedDevices(WorkStationID.toString()).toPromise()
    if (ddata?.some(d => d.enumDeviceCategoryID === DEVICE_CATEGORY.Printer)) {
        return true;
      } 
      else {
        return false;
      }

  }

  openReport(report:any){
    console.log("Opening report:", report);

      let documentIds: string[] = [];
      documentIds.push(report.model.DocumentID);
  
      const config = new MatDialogConfig();
      config.panelClass = 'standard-dialog';
      config.data = documentIds;
      config.maxWidth = '100vw';
      config.maxHeight = '100vh';
      config.width = '98%';
      config.height = '98%';
      console.log('ReferrerPortalReferralDetailComponent openReport:', config);
      this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
        //
      });    
  }

}
